#import "../../list/BusinessUnitFields.graphql"
mutation CompanyBusinessUnitCreate($input: CompanyBusinessUnitCreateInput!) {
  companyBusinessUnitCreate(input: $input) {
    companyBusinessUnitUpdateType {
      companyBusinessUnit {
        ...BusinessUnitFields
      }
      _isCompanyTokenRefreshRequired
      _companyRefreshId
    }
  }
}